import { Box, Typography, useTheme } from '@mui/material';

export const Logo = () => {
  const theme = useTheme();
  const fillColor = theme.palette.primary.main;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
      <img
        height={24}
        width={24}
        alt="logo"
        src="/assets/logo.png"
        style={{ objectFit: 'contain' }}
      />
      <Typography sx={{ color: fillColor }}>Truck Load Dashboard</Typography>
    </Box>
  );
};
